import { Field } from 'formik';
import PropTypes from 'prop-types';
import { _CheckboxWrapper as CheckboxWrapper } from './Checkbox.style';
import { _Label as Label } from '../../Styled/Label';
import ReactMarkdown from 'react-markdown';

export const Checkbox = ({ id, props }) => {
  const { label, required, name } = props;

  // Render for non-grouped checkbox
  return (
    <CheckboxWrapper htmlFor={id}>
      <div>
        <Field 
          id={id} 
          type='checkbox' 
          name={id === 'tacCheckbox' ? name : `form['${label}']`} 
          required={required} 
        />
        {id === 'tacCheckbox' ? (
          <ReactMarkdown className='tacText'>{`${label} *`}</ReactMarkdown>
        ) : (
          <label>{`${label} *`}</label>
        )}
      </div>
    </CheckboxWrapper>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  props: PropTypes.shape({
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
  }).isRequired,
  name: PropTypes.string, // Optional name prop
};
